class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.searchHeader = this.querySelector('#header-search');

    this.searchHeader.classList.remove("visible-live-search");
    this.searchHeader.classList.remove("no-results");

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.searchHeader.classList.remove("no-results");
    fetch(`/search/suggest?q=${searchTerm}&resources[limit]=10&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        if (resultsMarkup == "0") {
          this.predictiveSearchResults.innerHTML = "";
          this.searchHeader.classList.remove("visible-live-search");
          this.searchHeader.classList.add("no-results");
        } else {
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.searchHeader.classList.add("visible-live-search");

          let event = new Event("predictiveSearchLoaded", {
            bubbles: true
          });
          document.getElementsByTagName("body")[0].dispatchEvent(event);
    
          // this shit is 4 Wishlist hearts
          if (typeof reqJquery === "function") {
            reqJquery();
          }
        }
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.searchHeader.classList.remove("visible-live-search");
    this.searchHeader.classList.remove("no-results");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
